export default class OrdersCollection {
  constructor() {
    this.promotions = [];
    this.campaignId = undefined;
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.total = 0;
    this.query = null;

    this.sortColumn = 'created_at';
    this.sortDirection = 0;
  }
}